import { Star, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { formatDistanceToNow } from 'date-fns';

export const ReviewCard = ({ review, canDelete = false, onDelete }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${
          i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-600'
        }`}
      />
    ));
  };

  const formatDate = (dateString) => {
    try {
      return formatDistanceToNow(new Date(dateString), { addSuffix: true });
    } catch {
      return 'Recently';
    }
  };

  return (
    <div
      className="p-4 rounded-xl bg-[#1A1A1A] border border-white/5"
      data-testid={`review-${review.id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          {/* Header */}
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
              <span className="text-primary font-bold text-sm">
                {review.user_name.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <p className="font-semibold text-white">{review.user_name}</p>
              <p className="text-xs text-gray-500">{formatDate(review.created_at)}</p>
            </div>
          </div>

          {/* Stars */}
          <div className="flex items-center gap-1 mb-2">
            {renderStars(review.rating)}
          </div>

          {/* Review Text */}
          <p className="text-gray-300 text-sm leading-relaxed">{review.text}</p>
        </div>

        {/* Delete Button */}
        {canDelete && onDelete && (
          <Button
            variant="ghost"
            size="icon"
            className="text-gray-500 hover:text-red-400 hover:bg-red-400/10"
            onClick={() => onDelete(review.id)}
            data-testid={`delete-review-${review.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
